import * as constant from '../constants/ActionTypes';

function login(currentUri) {
  window.open(`/signin/?returnUri=${currentUri}`, '_self');
}
function dispatchCallUs(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_CALLUS,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}
function dispatchEmailUs(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_EMAIL,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchEmailUsNoIntent(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_EMAIL_NO_INTENT,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchLogin(currentUri, channel) {
  if (channel === 'callUs') {
    return dispatchCallUs(currentUri);
  }
  if (channel === 'email') {
    return dispatchEmailUsNoIntent(currentUri);
  }
  return dispatchEmailUs(currentUri);
}

module.exports = {
  dispatchLogin,
};
